<template>
  <span class="spinner" :style="spinnerStyle"></span>
</template>

<script>
export default {
  name: "GlobalUISpinner",
  props: {
    size: {
      type: [Number, String],
      default: 14,
    },
    borderWidth: {
      type: [Number, String],
      default: 2,
    },
  },
  computed: {
    spinnerStyle() {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
        borderWidth: `${this.borderWidth}px`,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.spinner {
  display: inline-block;

  border: 2px solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;

  animation: spinner-rotate 0.6s linear infinite;
}

@keyframes spinner-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
